export default __webpack_public_path__ + "static/media/videoStatus.df2a1120.svg";